import React from 'react'
import ResetPasswordForm from './ResetPasswordForm'

const ResetPassword = () => {
  return (
    <div>
        <ResetPasswordForm />
    </div>
  )
}

export default ResetPassword